import { render, staticRenderFns } from "./ConfigAlertPagerDuty.vue?vue&type=template&id=1fd96c8e&"
import script from "./ConfigAlertPagerDuty.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertPagerDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports